import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  HttpLink,
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import fetch from 'isomorphic-unfetch'
import getConfig from 'next/config'
import * as resolvers from './resolvers'
import getIdToken from 'utils/auth/getIdToken'
import { authorizeUser } from 'models/Auth'
import { captureException } from 'utils/sentry'

interface Global {
  fetch: any
}

declare var global: Global

const {
  publicRuntimeConfig: { uriEndpoint },
} = getConfig()

const IS_BROWSER = !!process.browser
if (IS_BROWSER) global.fetch = fetch

const httpLink = new HttpLink({
  uri: uriEndpoint,
  fetch,
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) console.log('graphqlErrors:', graphQLErrors)

  if (networkError) console.log('[Network error]:', networkError)
})

export function createApolloClient(
  initialState = {},
  token = null,
  req = null
) {
  const cache = new InMemoryCache().restore(initialState)

  const authLink = setContext(async (_, { headers }) => {
    console.info('initialToken', token)
    const newToken = token ? token : await genNewToken(req)
    console.info('newToken', newToken)

    if (!newToken) return { headers }

    return {
      headers: {
        ...headers,
        authorization: `Bearer: ${newToken}`,
      },
    }
  })

  return new ApolloClient({
    ssrMode: typeof window === 'undefined',
    connectToDevTools: IS_BROWSER,
    link: ApolloLink.from([errorLink, authLink, httpLink]),
    cache,
    resolvers,
  })
}

/**
 * サーバーサイドとクライアントサイドでtokenを取得する
 *
 */
async function genNewToken(req = null) {
  if (typeof window !== 'undefined') {
    const token = await authorizeUser().then(user => {
      if (!user) return null
      return user.getIdToken()
    })

    return token || null
  }

  if (req) {
    const token = await getIdToken(req).catch(e => {
      captureException(e)
      return null
    })

    return token
  }
}
